import { createContext, ReactNode, useContext } from "react";
import { DndSortZoneProps } from "../DndSortZone";

export type PreviewRendererParams = {
  valid: boolean; // Indicates if the item being dragged is valid for the current drop target
};

export type PreviewRenderer = (params: PreviewRendererParams) => ReactNode;

export type DndSortZoneContextValue =
  | (Omit<DndSortZoneProps, "sortedIds" | "orientation" | "gap"> & {
      sortable: boolean;
      sortedIds?: (string | number)[];
      orientation?: "horizontal" | "vertical";
    })
  | null;

export const DndSortZoneContext = createContext(
  null as DndSortZoneContextValue,
);

export const useDndSortZoneContext = () => {
  return useContext(DndSortZoneContext);
};
